<chiplist-ac [control]="field.control" [searchCtrl]="searchCtrl" [caption]="field.label | localize"
    [placeholder]="field.placeholder | localize" [options]="options$" [hint]="field.hint | localize"
    [readonly]="field.readonly" [required]="field.required" [id]="'userId'"></chiplist-ac>